const inbox = (intl, methodName) => ({
  type: intl.formatMessage({ id: 'type' }),
  'show in inbox': intl.formatMessage({ id: 'inbox.displayInInbox' }),
  'need push': intl.formatMessage({ id: 'inbox.needPush' }),
  title: intl.formatMessage({ id: 'name' }),
  'brand id': intl.formatMessage({ id: 'brand' }),
  name: intl.formatMessage({ id: 'name' }),
  'push content': intl.formatMessage({ id: 'inbox.pushContent' }),
  'push title': intl.formatMessage({ id: 'inbox.pushTitle' }),
  'push image': intl.formatMessage({ id: 'inbox.pushmImage' }),
  link_blocks: intl.formatMessage({ id: 'cms.linkBlock' }),
  'link_blocks.links': intl.formatMessage({ id: 'cms.link' }),
  'link_blocks.links.title': intl.formatMessage({ id: 'cms.link.name' }),
  'link_blocks.links.name': intl.formatMessage({ id: 'cms.link.name' }),
  'link_blocks.links.link_type': intl.formatMessage({ id: 'cms.link.type' }),
  'link_blocks.links.link_url': intl.formatMessage({ id: 'cms.link.path' }),
  'link_blocks.links.image': intl.formatMessage({ id: 'imageOnBehalf' }),
  'link_blocks.links.encrypt_key': intl.formatMessage({ id: 'cms.link.encryption.key' }),
  'link_blocks.links.encrypt_aes_iv': intl.formatMessage({ id: 'cms.link.encryption.iv' }),
  'link_blocks.links.parameters': intl.formatMessage({ id: 'cms.link.parameter.passedIn' }),
  'link_blocks.links.parameters.key': intl.formatMessage({ id: 'cms.link.parameter.name' }),
  'link_blocks.links.parameters.value': intl.formatMessage({ id: 'cms.link.parameter.value' }),
  ...(methodName => {
    switch (methodName) {
      case 'createInboxLineMessage':
      case 'updateInboxLineMessage':
        return {
          'push starts at': intl.formatMessage({ id: 'inbox.line.message.pushStartsAt' }),
          message_contents: intl.formatMessage({ id: 'inbox.line.message.content' }),
          'message_contents.type': intl.formatMessage({ id: 'inbox.line.message.content.type' }),
          'message_contents.value': intl.formatMessage({ id: 'inbox.line.message.content.value' }),
          'message contents': intl.formatMessage({ id: 'inbox.line.message.content' }),
          'message contents.image': intl.formatMessage({
            id: 'inbox.line.message.content.type.image',
          }),
        };
      default:
        return {};
    }
  })(methodName),
});

export default inbox;
